module.exports = __webpack_public_path__ + "static/media/2025-The-Debrief-Feature-Banner-md@1x.82801231.jpg";